import { lazyLoad } from 'utils/lazy';

export default lazyLoad(
  () => import('./Terminals'),
  (m) => m.default
);
